import { render, staticRenderFns } from "./post_Inquiry.vue?vue&type=template&id=79e361b8&scoped=true"
import script from "./post_Inquiry.vue?vue&type=script&lang=js"
export * from "./post_Inquiry.vue?vue&type=script&lang=js"
import style0 from "./post_Inquiry.vue?vue&type=style&index=0&id=79e361b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e361b8",
  null
  
)

export default component.exports